import * as tslib_1 from "tslib";
import { AuthService } from '../../auth.service';
import { AlertDialogService } from '../alert-dialog/alert-dialog.service';
import { SharedService } from '../shared.service';
import * as i0 from "@angular/core";
import * as i1 from "../../auth.service";
import * as i2 from "../shared.service";
import * as i3 from "../alert-dialog/alert-dialog.service";
var GUARDIAN_ACCESS_REQUEST_PATH = '/dashboard/request';
var AuthzAccessHintService = /** @class */ (function () {
    function AuthzAccessHintService(auth, sharedService, alertDialog) {
        this.auth = auth;
        this.sharedService = sharedService;
        this.alertDialog = alertDialog;
        this.dashboardConfigPromise = null;
    }
    // Show popup only when user lacks permission for the feature.
    AuthzAccessHintService.prototype.showAccessDeniedDialogForFeaturePanel = function (featureId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var authzPanels, guardianBaseUrl, requestUrl, message;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!featureId) {
                            return [2 /*return*/];
                        }
                        authzPanels = this.auth.getAuthzPanels();
                        if (!authzPanels.includes(featureId)) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.getGuardianDashboardBaseUrl()];
                    case 1:
                        guardianBaseUrl = _a.sent();
                        requestUrl = guardianBaseUrl ? "" + guardianBaseUrl + GUARDIAN_ACCESS_REQUEST_PATH : '';
                        message = requestUrl
                            ? "Access for " + featureId + " is managed in Guardian. Use the link below to request access."
                            : "Access for " + featureId + " is managed in Guardian.";
                        this.alertDialog.open({
                            title: 'Access Denied',
                            message: message,
                            confirmText: 'OK',
                            links: requestUrl
                                ? [{ label: requestUrl, url: requestUrl }]
                                : undefined,
                        });
                        // Wait for dialog to close before returning
                        return [4 /*yield*/, this.alertDialog.confirmed().toPromise()];
                    case 2:
                        // Wait for dialog to close before returning
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Get access hint data for footer display.
    AuthzAccessHintService.prototype.getAccessHintData = function (featureId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var authzPanels, guardianBaseUrl, requestUrl;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!featureId) {
                            return [2 /*return*/, null];
                        }
                        authzPanels = this.auth.getAuthzPanels();
                        if (!authzPanels.includes(featureId)) {
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, this.getGuardianDashboardBaseUrl()];
                    case 1:
                        guardianBaseUrl = _a.sent();
                        requestUrl = guardianBaseUrl ? "" + guardianBaseUrl + GUARDIAN_ACCESS_REQUEST_PATH : '';
                        return [2 /*return*/, {
                                message: 'Access for this panel is managed in Guardian.',
                                requestUrl: requestUrl,
                            }];
                }
            });
        });
    };
    AuthzAccessHintService.prototype.getGuardianDashboardBaseUrl = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadDashboardConfig()];
                    case 1:
                        config = _a.sent();
                        return [2 /*return*/, (config && config.guardianDashboardBaseUrl) || ''];
                }
            });
        });
    };
    AuthzAccessHintService.prototype.loadDashboardConfig = function () {
        var _this = this;
        if (!this.dashboardConfigPromise) {
            this.dashboardConfigPromise = this.sharedService.fetchDashboardConfig()
                .toPromise()
                .then(function (res) { return _this.sharedService.parseDashboardConfigResponse(res); })
                .catch(function () { return null; });
        }
        return this.dashboardConfigPromise;
    };
    AuthzAccessHintService.ngInjectableDef = i0.defineInjectable({ factory: function AuthzAccessHintService_Factory() { return new AuthzAccessHintService(i0.inject(i1.AuthService), i0.inject(i2.SharedService), i0.inject(i3.AlertDialogService)); }, token: AuthzAccessHintService, providedIn: "root" });
    return AuthzAccessHintService;
}());
export { AuthzAccessHintService };
